<template>
   <van-popup v-model:show="show" @click-overlay="() => playClickSound()" position="left"
      :style="{ height: '100%', width: '74%', zIndex: '10002', paddingBottom: '48px' }">

      <van-row class="navBar" justify="space-between">
         <van-col span="4" @click="closeSidebar" class="navBar_menu">
            <img src="@/assets/common/icon_back.png" alt="">
         </van-col>
         <van-col span="20" class="navBar_logo">
            <img src="@/assets/common/logo_688v.png" alt="">
         </van-col>
      </van-row>

      <van-row v-if="userStore.loginAccount" class="user_info">
         <van-col span="6" @click="closeSidebar" class="user_avatar">
            <img src="@/assets/common/head_icon.jpg" alt="">
         </van-col>
         <van-col span="18" class="user_text">
            <div class="user_account">{{ userAccount }}</div>
            <div class="user_ID">
               {{ $t('profile.id') }}：{{ uId }}
               <img src="@/assets/common/copy_icon.png" alt=""  @click="onCopyID(uId)">
            </div>
         </van-col>
      </van-row>
      <van-row v-if="!userStore.loginAccount" class="user_info">
         <van-col span="12" class="btn_col">
            <div class="loginButton" @click="openRegisterPopup(1)">{{ $t('common.login') }}</div>
         </van-col>
         <van-col span="12" class="btn_col">
            <div class="registerButton" @click="openRegisterPopup(0)">{{ $t('common.register') }}</div>
         </van-col>
      </van-row>
      <van-row class="button_group">
         <van-col span="12" class="btn_grid">
            <PrimaryButton :icon="require('@/assets/sideNavbar/home_recharge.png')" :text="$t('common.deposite')"
               textColor="#FFFFFF" bgColor="#3d2e22" @onClick="buttonClick('topup')" />
         </van-col>
         <van-col span="12" class="btn_grid">
            <PrimaryButton :icon="require('@/assets/sideNavbar/home_withdrawal.png')" :text="$t('common.sake')"
               textColor="#FFFFFF" bgColor="#3d2e22" @onClick="buttonClick('withdraw')" />
         </van-col>
      </van-row>
      <div>
         <van-row class="game_list" v-for="(item) in props.listGameData" :key="item.id" @click="goToGamePannel(item)"
            align="center">
            <van-col span="24" class="game_img_col">
               <img class="game_icon" :src="item.customIcon" alt="" />
            </van-col>
         </van-row>
      </div>
      <div class="menu_list">
         <van-row class="menu_row">
            <van-col span="11" v-for="(item, index) in menuList" :key="index" class="menu_grid_item">
               <div class="menu_item_inner" @click="menuClick(item.name)">
                  <img class="menu_item_icon" :src="item.activity_icon" alt="" />
                  <div class="menu_item_text">{{ t(`activityName.${item.name}`) }}</div>
               </div>
            </van-col>
         </van-row>
      </div>
      <div class="share_content">
         <div class="share_item" v-for="(item, index) in shareList" :key="index">
            <img :src="item.img" alt="" @click="goToShare">
         </div>
      </div>

   </van-popup>
   <CollectPopup ref="collectPopupRef" />
   <CollectTimeDropPopup ref="collectTimeDropPopupRef" />
   <StatusPopup ref="statusRef" :content="$t('common.copied')" :isShowSuccess="true" />
   <AgentPopup ref="agentRef" />
   <PwaAntiBlockingPopup ref="pwaPopupRef" />
   <PwaStatusPopup ref="pwaPopupStatusRef" />
</template>

<script setup lang="ts">
import { computed, defineExpose, inject, ref, defineProps, onMounted, defineEmits } from 'vue'
import PrimaryButton from '../common/primaryButton.vue'
import { useRouter } from 'vue-router'
import CollectPopup from '@/view/collect/collectPopup.vue'
import CollectTimeDropPopup from '@/view/collect/collectTimeDropPopup.vue'
import AgentPopup from '@/view/agent/agentPopup.vue'
import { playClickSound } from '@/utils/media'
import { useI18n } from 'vue-i18n';
import { useActivityStore } from '@/stores/activity'
import { useUserStore } from '@/stores/user'
import PwaAntiBlockingPopup from '../common/pwaAntiBlockingPopup.vue'
import PwaStatusPopup from '../common/pwaStatusPopup.vue'
import StatusPopup from '@/components/common/statusPopup.vue'
import { goToShare, handleMenuClick, SHARE_LIST, SideMenuListItem, useButtonClick } from '@/view/components/supportFunction'
import { copyID } from '@/view/profile/supportScript'
const activityStore = useActivityStore()
const userStore = useUserStore()
const userAccount = computed(() => userStore.loginAccount)
const uId = computed(() => userStore.id)
const { t } = useI18n();
const { buttonClick } = useButtonClick()
const router = useRouter()
const show = ref(false)
const menuList = computed<SideMenuListItem[]>(() => activityStore.activityList)

const shareList = ref(SHARE_LIST)

const openRegisterLoginPopup = inject<(type: number) => void>('openRegisterLoginPopup')
const statusRef = ref()
const collectPopupRef = ref()
const collectTimeDropPopupRef = ref()
const agentRef = ref()
const emits = defineEmits(['goToGamePanelSlide'])
const token = ref(localStorage.getItem('token'))
const isLogin = ref(token.value ? true : false)
const pwaPopupRef = ref()
const pwaPopupStatusRef = ref()
const canRecievedRewards = computed(() => userStore?.PWAConvertData?.canReceiveReward)
const isOpen = computed(() => userStore?.PWAConvertData?.config?.isOpen)
const openSidebar = () => {
   show.value = true
}

const closeSidebar = () => {
   playClickSound()
   show.value = false
}
const openRegisterPopup = (type: number) => {
   openRegisterLoginPopup?.(type)
}
const props = defineProps<{
   listGameData: Array<{
      name: string,
      customIcon: string,
      id: number | string,
      groupType: number,
   }>
}>()

const onCopyID = (id : any) => copyID(statusRef, id)

const menuClick = (name: any) => {
   handleMenuClick(name, router, agentRef, collectPopupRef, collectTimeDropPopupRef,
      pwaPopupRef, pwaPopupStatusRef, show, canRecievedRewards.value, isOpen.value, t
   )

}
const goToGamePannel = (data: any) => {
   emits('goToGamePanelSlide', data)
}

defineExpose({
   openSidebar,
   closeSidebar
})

</script>
<style scoped>
.navBar {
   position: sticky;
   top: 0;
   left: 0;
   right: 0;
   width: 100%;
   z-index: 2000;
   padding-top: 15px;
   background-image: url('@/assets/main_bg.png');
   background-size: cover;
   background-repeat: repeat;
}

.navBar_menu {
   display: flex;
   align-items: center;
   justify-content: center;
   padding: 0 8px;
}

.navBar_menu img {
   width: 28px;
}

.navBar_logo {
   display: flex;
   align-items: center;
   justify-content: right;
   padding: 8px 15px;
}

.navBar_logo img {
   width: 100px;
}

.van-popup {
   background-image: url('@/assets/main_bg.png');
   background-size: cover;
   background-repeat: repeat;
   -ms-overflow-style: none;
   scrollbar-width: none;
   overflow-y: auto;
}

.van-popup::-webkit-scrollbar {
   display: none;
}

.button_group {
   display: flex;
   justify-content: center;
   padding: 5px 17.5px 0;
}

.btn_grid {
   padding: 4px;
}

.van-overlay {
   backdrop-filter: blur(5px);
   -webkit-backdrop-filter: blur(5px);
   z-index: 10001 !important;
}

.menu_list {
   padding: 12px;
   position: relative;
}

.menu_icon {
   width: 100%;
   margin-bottom: 10px;
}

.menu_grid_item {
   background: rgba(61, 46, 34, 0.75);
   color: rgba(255, 255, 255, 0.45);

   margin: 5px;
   box-sizing: border-box;
   border-radius: 5px;
}

.menu_item_inner {
   border-radius: 5px;
   display: flex;
   flex-direction: column;
   align-items: center;
   padding: 5px 5px;
}

.menu_item_icon {
   width: 25px;
   height: 25px;
   object-fit: contain;
   margin-bottom: 3px;
   border-radius: 5px;
}

.menu_item_text {
   font-size: 12px;
   text-align: center;
   color: #ffffff;
}

.game_list {
   background: rgba(61, 46, 34, 0.75);
   color: rgba(255, 255, 255, 0.45);
   border-radius: 10px;
   margin: 5px 20px;
   padding: 7px;
   position: relative;
   cursor: pointer;
}

.game_img_col {
   display: flex;
   justify-content: center;
   align-items: center;
}

.game_icon {
   width: auto;
   height: 35px;
   border-radius: 5px;
   object-fit: cover;
}

.game_name_col {
   display: flex;
   align-items: center;
   justify-content: center;
   text-align: center;
   height: 100%;
   flex-direction: column;
}


.game_name {
   font-size: 15px;
   color: #fff;
   margin-left: 10px;
}


.menu_img img {
   width: 25px;
}

.menu_text {
   color: #FFFFFF;
   font-size: 15px;
   font-weight: 400;
}

.menus {
   padding: 7.5px 0;
   position: relative;
}

.menu_icon_img {
   position: absolute;
   bottom: 0;
   right: 0;
   width: 82px;
   height: auto;
}

.share_content {
   border: 1px solid rgba(255, 255, 255, 0.3);
   border-radius: 10px;
   margin: 25px;
   padding: 5px 10px;
   display: flex;
   justify-content: center;
}

.share_item {
   border-radius: 30px;
   background: #7d7d7d12;
   width: 36px;
   height: 36px;
   margin: 5px;
}

.share_item img {
   width: 40px;
}

.user_info {
   background: rgba(61, 46, 34, 0.75);
   color: rgba(255, 255, 255, 0.45);
   border-radius: 10px;
   margin: 0 20px;
   padding: 5px 10px;
}

.btn_col {
   padding: 2.5px;
   display: flex;
   justify-content: center;
   align-items: center;
}

.loginButton {
   background-image: linear-gradient(180deg, #F8D8A7 0%, #F0A853 100%);
   border-radius: 5px;
   color: #12151A;
   font-size: 16px;
   font-weight: 400;
   padding: 10px;
   display: flex;
   justify-content: center;
   width: 90px;
}

.registerButton {
   border: 1px solid #DD7A33;
   border-radius: 5px;
   color: #DD7A33;
   font-size: 16px;
   font-weight: 400;
   padding: 10px;
   display: flex;
   justify-content: center;
   width: 90px;
}

.user_avatar img {
   width: 12vw;
   border-radius: 10px;
   border: 1px solid rgba(184, 204, 203, 1);
}

.user_account {
   color: #fff;
   font-weight: bold;
   font-size: 4vw;
   padding-top: 5px;
   padding-left: 5px;
}

.user_ID {
   color: #fff;
   padding-top: 5px;
   padding-left: 5px;
   display: flex;
   align-items: end;
   font-size: 3.5vw;
}

.user_ID img {
   width: 14px;
   padding-left: 5px;
}

@media (min-width: 450px) {
   .user_avatar img {
      width: 45px;
   }

   .user_ID {
      font-size: 12.8px;
   }

   .user_account {
      font-size: 15px;
   }

   .van-popup {
      width: 70% !important;
   }
}

.btn_grid .btn_text {
   font-size: 1px !important;
}
</style>